import {
  faPlus,
  faTrash,
  faArrowDownShortWide,
  faArrowUpShortWide,
} from "@awesome.me/kit-c1b85ff10f/icons/classic/light";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  getAllCarriersFromCarrierConfigurations,
  getAllCompanies,
} from "../../../Components/Selects/AsyncSelect/api";
import { useTypes } from "../../../utilities/types";
import { useIndexContractsContext } from "../providers/Index";
import { useAppContext } from "../../../AppProvider";
import {
  getCarrierConfigurationOptionStyle,
  getCompanyOptionStyle,
} from "../../../Components/Selects/AsyncSelect/styles";

export const useListProps = () => {
  const { shipments, contractTypes } = useTypes();
  const context = useIndexContractsContext();
  const { dictionary } = useAppContext();

  return {
    path: `/contract-service/contracts`,
    banner: {
      enabled: true,
    },
    sorting: [
      {
        orderBy: "desc",
        column: "name",
        icon: faArrowDownShortWide,
        label: dictionary.registries.name,
        isDefault: true,
      },
      {
        orderBy: "asc",
        column: "name",
        icon: faArrowUpShortWide,
        label: dictionary.registries.name,
        isDefault: false,
      },
      {
        orderBy: "desc",
        column: "validityFrom",
        icon: faArrowDownShortWide,
        label: dictionary.times.validity_from,
        isDefault: false,
      },
      {
        orderBy: "asc",
        column: "ValidityFrom",
        icon: faArrowUpShortWide,
        label: dictionary.times.validity_from,
        isDefault: false,
      },
      {
        orderBy: "desc",
        column: "validityTo",
        icon: faArrowDownShortWide,
        label: dictionary.times.validity_to,
        isDefault: false,
      },
      {
        orderBy: "asc",
        column: "ValidityTo",
        icon: faArrowUpShortWide,
        label: dictionary.times.validity_to,
        isDefault: false,
      },
    ],
    omnisearch: {
      enabled: true,
      placeholder: dictionary.actions.search,
    },
    pagination: { enabled: true },
    title: dictionary.contracts.contracts,
    create: {
      enabled: true,
      action: () =>
        context?.setModalConfig({
          isOpen: true,
          action: "create",
          size: "md",
          title: dictionary.actions.add,
        }),
      title: dictionary.actions.add,
      icon: faPlus,
    },
    selectRowsEnabled: { enabled: true },
    massiveActions: [
      {
        onClick: (selectedRows) =>
          context.setModalConfig({
            isOpen: true,
            size: "sm",
            title: dictionary.actions.delete_selected,
            action: "delete",
            data: selectedRows.map((item) => item.id),
          }),
        label: dictionary.actions.delete_selected,
        icon: <FontAwesomeIcon icon={faTrash} />,
        className: "button-1 button-1-danger",
      },
    ],
    filters: {
      name: "contracts",
      preserve: false,
      list: [
        {
          fieldName: "ownerId",
          label: dictionary.registries.owner,
          type: "async-select",
          isMulti: true,
          loadOptions: (searchValue, pagination) => {
            const params = {
              inputValue: searchValue,
              pagination,
              sorting: { selector: "name", orderBy: "asc" },
            };
            return getAllCompanies(params);
          },
          optionStyle: (option) => {
            const CompanyOption = getCompanyOptionStyle(option);
            return <CompanyOption />;
          },
          primary: true,
          col: 3,
        },
        {
          fieldName: "carrierCode",
          searchKey: "carrierCode",
          label: dictionary.registries.carriers,
          type: "async-select",
          isMulti: true,
          loadOptions: (searchValue, pagination) => {
            const params = {
              inputValue: searchValue,
              pagination,
              sorting: { selector: "name", orderBy: "asc" },
            };
            return getAllCarriersFromCarrierConfigurations(params);
          },
          optionStyle: (option) => {
            const CarrierConfigurationOption =
              getCarrierConfigurationOptionStyle(option);
            return <CarrierConfigurationOption />;
          },
          primary: true,
          col: 3,
        },
        {
          fieldName: "name",
          label: dictionary.registries.name,
          type: "text",
          primary: true,
          col: 3,
        },
        {
          fieldName: "shipmentType",
          label: dictionary.shipments.shipment_typology,
          type: "select",
          options: shipments,
          primary: true,
          col: 3,
        },
        {
          fieldName: "type",
          label: dictionary.contracts.contract_typology,
          type: "select",
          options: contractTypes,
          primary: false,
          col: 3,
        },
      ],
    },
  };
};
